import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { MiniQuestionnaireData } from "@/types/miniQuestionnaire";

interface MiniSection5Props {
  data: MiniQuestionnaireData;
  updateData: (field: keyof MiniQuestionnaireData, value: string) => void;
}

const MiniSection5 = ({ data, updateData }: MiniSection5Props) => {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-semibold text-feel-foreground mb-6">
        Section VII – Nutrition
      </h2>

      {/* Question 9 - Viande rouge */}
      <div className="space-y-3">
        <Label className="text-lg font-medium text-feel-foreground">
          Q9. Combien de fois par semaine consommez-vous de la viande rouge (bœuf, porc, agneau…) ?
        </Label>
        <RadioGroup
          value={data.viande_rouge_frequence}
          onValueChange={(value) => updateData("viande_rouge_frequence", value)}
          className="space-y-2"
        >
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="4_fois_plus" id="viande-4plus" />
            <Label htmlFor="viande-4plus" className="cursor-pointer">4 fois ou plus par semaine</Label>
          </div>
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="2_3_fois" id="viande-2-3" />
            <Label htmlFor="viande-2-3" className="cursor-pointer">2 à 3 fois par semaine</Label>
          </div>
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="0_1_fois" id="viande-0-1" />
            <Label htmlFor="viande-0-1" className="cursor-pointer">0 à 1 fois par semaine</Label>
          </div>
        </RadioGroup>
      </div>

      {/* Question 10 - Régime méditerranéen */}
      <div className="space-y-3">
        <Label className="text-lg font-medium text-feel-foreground">
          Q10. Votre alimentation s'inspire-t-elle du régime méditerranéen (riche en fruits, légumes, céréales complètes, légumineuses, huile d'olive, poisson, fruits secs et pauvre en viande rouge et produits transformés) ?
        </Label>
        <RadioGroup
          value={data.regime_mediterraneen}
          onValueChange={(value) => updateData("regime_mediterraneen", value)}
          className="space-y-2"
        >
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="pas_du_tout" id="med-non" />
            <Label htmlFor="med-non" className="cursor-pointer">Pas du tout – Mon alimentation est très éloignée du modèle méditerranéen</Label>
          </div>
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="en_partie" id="med-partie" />
            <Label htmlFor="med-partie" className="cursor-pointer">Oui, en partie – J'en applique certains principes mais pas tous</Label>
          </div>
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="tout_a_fait" id="med-oui" />
            <Label htmlFor="med-oui" className="cursor-pointer">Oui, tout à fait – Mon alimentation est principalement de type méditerranéen</Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};

export default MiniSection5;
